module.exports = __webpack_public_path__ + "static/img/finance_bg.739d9e60.png";